import { toCodePointChar } from "#to-code-point-char";

/** Matches a leading code point with the Unicode binary property `Grapheme_Extend`. */
export const GRAPHEME_EXTEND_REGEX = /^\p{Grapheme_Extend}/u;

/**
 * True if the first code point extends a preceding base in a grapheme cluster (variation
 * selectors, combining marks, etc.) — Unicode binary property `Grapheme_Extend`.
 */
export function isGraphemeExtend(value: string | number): boolean {
  return GRAPHEME_EXTEND_REGEX.test(toCodePointChar(value));
}
